var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17667 6.14667C1.17303 6.14667 1.16939 6.14667 1.16502 6.14667C0.705704 6.14667 0.333008 6.51808 0.333008 6.97743C0.333008 7.43679 0.704976 7.8082 1.16502 7.8082C1.16939 7.8082 1.17303 7.8082 1.1774 7.8082H12.8227C12.8263 7.8082 12.83 7.8082 12.8343 7.8082C13.2936 7.8082 13.6663 7.43679 13.6663 6.97743C13.6663 6.51808 13.2944 6.14667 12.8343 6.14667C12.83 6.14667 12.8263 6.14667 12.8219 6.14667H1.17667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.832 1.16271C7.832 1.15907 7.832 1.15544 7.832 1.15108C7.832 0.69245 7.46003 0.320312 6.99998 0.320312C6.53994 0.320312 6.16797 0.691723 6.16797 1.15108C6.16797 1.15544 6.16797 1.15907 6.16797 1.16344V1.16271V12.7913C6.16797 12.7949 6.16797 12.7985 6.16797 12.8029C6.16797 13.2615 6.53994 13.6337 6.99998 13.6337C7.46003 13.6337 7.832 13.2623 7.832 12.8029C7.832 12.7985 7.832 12.7949 7.832 12.7905V12.7913V1.16271Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4b20f8b71d3fff7932b89f0b40e30ef9.svg";
export { ForwardRef as ReactComponent };